module.exports = __webpack_public_path__ + "files/0b7ffc847cb5b3303872ddb4b2cb507c.png";